export const isLinkWithProtocol = (link) =>
  link.match(/^((http|https|ftp):\/\/)/);
